<template>
  <v-card class="mb-4">
    <v-toolbar flat color="second" dark>
        <v-toolbar-title>Infos</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
        <v-list>
            <template v-if="order.prescription">
                <v-list-item>
                    <v-list-item-content
                    >Prescription Number:</v-list-item-content
                    >
                    <v-list-item-content class="align-end"
                    >#{{ order.prescription.id }}</v-list-item-content
                    >
                </v-list-item>
                <v-list-item>
                    <v-list-item-content
                    >Prescription status:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                    <b>{{ order.prescription.statusId }}</b>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <v-list-item>
                <v-list-item-content>Order Number:</v-list-item-content>
                <v-list-item-content class="d-flex flex-row">
                    <div>
                        #{{ order.id }}
                        <v-btn icon x-small :href="'/orders/view/' + order.id" target="_blank">
                            <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                    </div>
                </v-list-item-content>
                </v-list-item>
                <v-list-item>
                <v-list-item-content>Order status:</v-list-item-content>
                <v-list-item-content class="align-end">
                    <b>{{ order.statusId }}</b>
                </v-list-item-content>
            </v-list-item>
            <template v-if="build.status_id">
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content>Build Status:</v-list-item-content>
                    <v-list-item-content class="align-end"
                    ><b>{{ build.status_id }}</b></v-list-item-content
                    >
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content>Builder</v-list-item-content>
                    <v-list-item-content class="align-end">
                    {{ build.builder_id ? build.builder.displayName : 'not attributed' }}
                    </v-list-item-content>
                </v-list-item>
            </template>
            <template v-if="handling">
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content>Handling Status:</v-list-item-content>
                    <v-list-item-content class="align-end"
                    ><b>{{ handling.status_id }}</b></v-list-item-content
                    >
                </v-list-item>
            </template>
        </v-list>
    </v-card-text>
    <v-card-actions v-if="isEmptyOrder">
        <v-btn @click="doComplete">
            Create Invoice and close building
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props:{
        order:{
            type:Object,
            required:true
        },
        build:{
            type:Object,
            required:true
        },
        handling:{
            type:Object,
            default: () => null
        }
    },
    computed: {
        isEmptyOrder () {
            return this.build.status_id == 'new' && this.order.rows.length == 0 && this.order.total > 0
        }
    },
    methods: {
        ...mapActions('build', ['createInvoiceAndCloseBuilding']),
        doComplete(){
            this.createInvoiceAndCloseBuilding(this.build.id)
            .then(() => {
                this.$emit('change')
            })
        }
    }
}
</script>

<style>

</style>